/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cta_FiverrInputs */

const en_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order in Fiverr`)
};

const ar_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اطلب عبر Fiverr`)
};

const bn_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফাইভারে অর্ডার করুন`)
};

const de_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über Fiverr beauftragen`)
};

const es_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contratar en Fiverr`)
};

const fr_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Me contacter sur Fiverr`)
};

const pt_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contratar pelo Fiverr`)
};

const zh_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订单以 Fiverr 为单位`)
};

const tr_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiverr'da Sipariş Ver`)
};

const ru_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказ в Fiverr`)
};

const pl_cta_fiverr = /** @type {(inputs: Cta_FiverrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamówienie w Fiverr`)
};

/**
* | output |
* | --- |
* | "Order in Fiverr" |
*
* @param {Cta_FiverrInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const cta_fiverr = /** @type {((inputs?: Cta_FiverrInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cta_FiverrInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_cta_fiverr(inputs)
	if (locale === "bn") return bn_cta_fiverr(inputs)
	if (locale === "de") return de_cta_fiverr(inputs)
	if (locale === "es") return es_cta_fiverr(inputs)
	if (locale === "fr") return fr_cta_fiverr(inputs)
	if (locale === "pt") return pt_cta_fiverr(inputs)
	if (locale === "zh") return zh_cta_fiverr(inputs)
	if (locale === "tr") return tr_cta_fiverr(inputs)
	if (locale === "ru") return ru_cta_fiverr(inputs)
	if (locale === "pl") return pl_cta_fiverr(inputs)
	return en_cta_fiverr(inputs)
});